import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import useToken from '../hooks/useToken';
import { API_ENDPOINTS } from '../utils/config';
import Skeleton from './skeleton/Skeleton';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

const Categories = () => {
    const { token } = useToken(); 
    const [categories, setCategories] = useState([]);
    const [hasError, setHasError] = useState(false);
    const [activeIndex, setActiveIndex] = useState(1);
    
    const fetchCategories = useCallback( async () => {
        try {
            const response = await axios.get( `${API_ENDPOINTS.CATEGORY_ENDPOINT}/20`, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if ( response.status === 200 && response.data?.items ) {
                setCategories( response.data.items );
            } else {
                setHasError( true );
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            setHasError(true);
        }
    }, [token]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    return (
        <div className="swiper-container">
            {hasError ? (
                <p className="text-danger">Failed to load categories. Please try again later.</p>
            ) : (
                <>
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={10}
                        slidesPerView={5}
                        loop={true}
                        navigation={{
                            prevEl: '.btn-prev',
                            nextEl: '.btn-next',
                        }}
                        breakpoints={{
                            "@0.00": {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            "@0.75": {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                            "@1.00": {
                                slidesPerView: 5,
                                spaceBetween: 15,
                            }
                        }}
                        onSlideChange={(swiper) => setActiveIndex(Math.max(1, (swiper.realIndex ?? 0) + 1))}
                        onSwiper={(swiper) => setActiveIndex(Math.max(1, (swiper.realIndex ?? 0) + 1))}
                        autoplay={{ delay: 160000 }}
                    >
                        {categories.length > 0 ? (
                            categories.map((category) => (
                                <SwiperSlide key={category.term_id}>
                                    <div className="cat-left">
                                        <Link
                                        to={`/category/${category.slug}`}
                                        className="text-2 text-decoration-none fw-600"
                                        >
                                            {category.name}
                                        </Link>
                                        <span className="text-2 fw-400">
                                            { category.count} {category.count === 1 ? 'article' : 'articles' }
                                        </span>
                                    </div>
                                    <span className={category.icon_class ? category.icon_class : 'icon-blog' }></span>
                                </SwiperSlide>
                            ))
                        ) : (
                            <Skeleton type="categories" />
                        )}
                    </Swiper>
                    <div className="swiper-nav-wrapper mt-3">
                        <div className="swiper-pag swiper-pagination-fraction swiper-pagination-horizontal">
                            <span className="swiper-pagination-current">{Number.isNaN(activeIndex) || !activeIndex ? 1 : activeIndex}</span>
                            <span className="divider">&ndash;</span>
                            <span className="swiper-pagination-total">{categories.length || 0}</span>
                        </div>
                        <div className="swiper-nav">
                            <div className="swiper-btn btn-prev"><FontAwesomeIcon icon={faArrowLeft} /></div>
                            <div className="swiper-btn btn-next"><FontAwesomeIcon icon={faArrowRight} /></div>
                        </div>   
                    </div>
                </>
            )}
        </div>
    );
};

export default Categories;
